import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App } from './App';
import { BrowserRouter } from 'react-router-dom';

if (process.env.REACT_APP_TARGET !== 'prod') {
  // Log analytics calls to console, unless in prod
  (window as any).analytics = {
    identify(...args: any[]) {
      console.log('identify: ', args);
    },
    track(...args: any[]) {
      console.log('track: ', args);
    },
    page(...args: any[]) {
      console.log('page: ', args);
    },
  };
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx